import { getStylesObjFromCss } from "../../../utils/common/styling";

export const styles = getStylesObjFromCss({
  styles: {
    postTypeMediaButton: {
      cursor: "pointer",
      borderRadius: "50%",
      padding: "4px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      overflow: "hidden",
    },
  },
  componentName: "PostTypeMediaButton",
});
